import React from 'react';
import Select from 'react-select';

import { useDispatch, useSelector } from 'react-redux';
import { searchOffices, clearOfficeSearch } from '@redux/modules/office';

import useObjectState from '@hooks/useObjectState';

import Button from '@components/smartAdminUI/Button';
import InputGroup from '@components/smartAdminUI/input/InputGroup';

const options = [
  { label: 'Active', value: 'A' },
  { label: 'Inactive', value: 'I' },
  { label: 'Pending', value: 'P' },
  { label: 'Suspended', value: 'S' },
  { label: 'Terminated', value: 'T' },
];

const initialState = {
  OfficeMlsId: '',
  OfficeManagerMlsId: '',
  OfficeManagerFullName: '',
  officeName: '',
  OfficeCity: '',
  OfficeStatus: options[0],
};
const OfficeAdvancedSearch = () => {
  const officeSearchLoading = useSelector(state => state.office.isLoading);

  // custom hook, takes a key:value pair an merges into state object (immutably)
  const [searchBarState, setSearchBarState] = useObjectState(initialState);
  const dispatch = useDispatch();

  const handleSubmit = e => {
    e.preventDefault();
    dispatch(searchOffices({
      ...searchBarState,
      OfficeStatus: searchBarState.OfficeStatus.value,
    }));
  };
  const handleReset = () => {
    setSearchBarState(initialState);
    dispatch(clearOfficeSearch());
  };

  return (
    <form className="col" onSubmit={handleSubmit}>
      <div className="form-row form-group">
        <div className="col-md-4 mb-1">
          <InputGroup
            autoComplete="off"
            id="inputField"
            type="text"
            label="MLSID"
            value={searchBarState.OfficeMlsId}
            onChange={({ target }) => setSearchBarState({ OfficeMlsId: target.value })}
            placeholder=""
          />
        </div>
        <div className="col-md-4 mb-1">
          <InputGroup
            autoComplete="off"
            id="inputField"
            type="text"
            label="Manager or Broker MLSID"
            value={searchBarState.OfficeManagerMlsId}
            onChange={({ target }) => setSearchBarState({ OfficeManagerMlsId: target.value })}
            placeholder=""
          />
        </div>
        <div className="col-md-4 mb-1">
          <InputGroup
            autoComplete="off"
            id="inputField"
            type="text"
            label="Manager or Broker Name"
            value={searchBarState.OfficeManagerFullName}
            onChange={({ target }) => setSearchBarState({ OfficeManagerFullName: target.value })}
            placeholder=""
          />
        </div>
      </div>
      <div className="form-row form-group">
        <div className="col-md-4 mb-1">
          <InputGroup
            autoComplete="off"
            id="inputField"
            type="text"
            label="Office Name"
            value={searchBarState.OfficeName}
            onChange={({ target }) => setSearchBarState({ OfficeName: target.value })}
            placeholder=""
          />
        </div>
        <div className="col-md-4 mb-1">
          <InputGroup
            // disabled
            autoComplete="off"
            id="inputField"
            type="text"
            label="City"
            value={searchBarState.OfficeCity}
            onChange={({ target }) => setSearchBarState({ OfficeCity: target.value })}
            placeholder=""
          />
        </div>
        <div className="col-md-4 mb-1">
          <label className="form-label" htmlFor="office-status">
            Status
          </label>
          <Select
            autoComplete="off"
            className="react-select-container"
            classNamePrefix="react-select"
            id="office-status"
            closeMenuOnSelect
            options={options}
            value={searchBarState.OfficeStatus}
            placeholder="Choose one" // should the initial value always Active instead of a placeholder?
            onChange={OfficeStatus => setSearchBarState({ OfficeStatus })}
          />
        </div>
      </div>
      <Button name="btnSearchOffice" variant="primary" type="submit">
        {officeSearchLoading ? (
          <>
            <span
              className="spinner-border spinner-border-sm mr-2"
              role="status"
              aria-hidden="true"
            />
            Searching...
          </>
        ) : (
          <>
            <i className="fas fa-search mr-2" aria-hidden="true" />
            Search
          </>
        )}
      </Button>
      <Button
        name="btnSearchOfficeClear"
        onClick={handleReset}
        variant="primary"
      >
        <i className="fas fa-times mr-2" />
        Clear
      </Button>
    </form>
  );
};

export default OfficeAdvancedSearch;
